import type { NavigationGuardNext, RouteRecordNormalized } from "vue-router"
import {$auth} from "@/plugins/auth"
import {ROUTES} from "@/router/paths"
import route from "@/plugins/route"
import {roles} from "@/enums/roles"

export default class Subscribed implements App.Middleware.Instance {
  async handle(
    to: RouteRecordNormalized,
    from: RouteRecordNormalized,
    next: App.Middleware.Caller,
    cancel: NavigationGuardNext
  ): Promise<void> {
    if (
      $auth.user!.account!.has_active_subscription ||
      $auth.user!.role === roles.LIBRA_ADMIN ||
      $auth.user!.account.original_owner!.role === roles.LIBRA_ADMIN
    ) {
      return next(to, from, cancel)
    }

    return cancel(route(ROUTES.PAYMENT, {plan: 'annual'}))
  }
}
